export default __webpack_public_path__ + "static/media/check-square.0b808c4d.svg";